import Cookies from 'js-cookie'
import { localRead,localSave ,localRemove} from '@/utils/tools'


export function getToken(label) {
  return localRead(label+'_admin_token')
}

export function setToken(token,label) {
  return localSave(label+'_admin_token', token)
}

export function removeToken(label) {
  return localRemove(label+'_admin_token')
}
